var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapRulerCenterDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4H13V7.10002C14.9591 7.4977 16.5023 9.04087 16.9 11H20V13H16.9C16.5023 14.9591 14.9591 16.5023 13 16.9V20H11V16.9C9.04087 16.5023 7.4977 14.9591 7.10002 13H4V11H7.10002C7.4977 9.04087 9.04087 7.4977 11 7.10002V4ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRulerCenterDay);
export default __webpack_public_path__ + "static/media/map_ruler_center_day.22a3d9bc437593de55f5881ec73983ac.svg";
export { ForwardRef as ReactComponent };